import TrialDetail from "./Screens/TrialDetail";
import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { DogSignUp } from "./DogSignUp";
import { useQuery, useLazyQuery } from "@apollo/client";
import { getDogsQuery } from "redux/features/dogSlice/dogGql";
import { getTrialCalendarByIdQuery } from "redux/features/trailResultSlice/trailResultGql";
import { PageProvider } from "shared/context/paginationCotnext";
import PageInfo from "shared/Components/pageInfo";
import { globalVariables } from "helper/globalVariables";

export const TrialDetails = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const location = useLocation();
  
  const isMemberUser = location.pathname.includes("dashboard");

  const [selectDogs, setSelectDogs] = useState([]);

  const [dogSignUp, setDogSignup] = useState(false);

  const [getTrialCalendarById, { data: trialCalendarData}] =
    useLazyQuery(getTrialCalendarByIdQuery, {
      fetchPolicy: "network-only",
    });

  const { data: dogsData } = useQuery(getDogsQuery, {
    fetchPolicy: "no-cache",
  });

  const trialDetails = trialCalendarData?.getTrialCalendarById || [];

  useEffect(() => {
    if (id) {
      getTrialCalendarById({
        variables: {
          trialCalendarId: parseInt(id, 10),
        },
      });
    }
  }, [id, getTrialCalendarById]);

  useEffect(() => {
    if (dogsData) {
      setSelectDogs(dogsData?.getMyRegisteredDogs ?? []);
    }
  }, [dogsData]);

  return (
    <PageProvider>
      <div
        className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10"
      >
        <PageInfo 
          title={dogSignUp ? globalVariables.dogSignup : globalVariables.trialDetails}
          onClick={() => navigate(-1)}
        />
        {dogSignUp && trialDetails.id ? (
          <DogSignUp
            dogSuggestions={selectDogs}
            detail={trialDetails}
            setDogSignup={(dogSignUpData, success = false) => {
              setDogSignup(dogSignUpData);
            }}
          />
        ) : trialDetails.id ? (
          <TrialDetail
            detail={trialDetails}
            setDogSignup={setDogSignup}
            isMemberUser={isMemberUser}
          />
        ) : null}
      </div>
    </PageProvider>  
  );
};
